export const getAltText = (author: string, username: string): string =>
  `Photo by ${author} (https://unsplash.com/@${username}?utm_source=identiteitsplein&utm_medium=referral) on Unsplash(https://unsplash.com)`
